export default "__VITE_ASSET__CMxrhWGF__"